/**
 * Display-only relabels for prompt keys whose stored value names document 3's
 * old concept (Q15). The keys themselves are NOT renamed — `PromptConfiguration
 * .DefinitionKey` rows and the catalog are keyed on them — so this map is read
 * only where a key reaches the screen. The document-3 brief and the
 * why-this-offer key were retired from the catalog (owner ruling Q9), so only
 * the EBITDA estimate's key is still relabelled.
 */
const PROMPT_KEY_DISPLAY_LABEL: Record<string, string> = {
  "buyers.offer-ebitda-estimate": "buyers.indication-ebitda-estimate",
};

/** The label a prompt key is shown under; every other key shows as stored. */
export function promptKeyDisplayLabel(key: string): string {
  return PROMPT_KEY_DISPLAY_LABEL[key] ?? key;
}
